<template>
  <section>
    <el-row>
      <el-col :span="6">
        <el-input placeholder="Please input Search Words" v-model="searchKey" prefix-icon="el-icon-fa-search">
          <div slot="append">
            <el-button type="primary" icon="el-icon-fa-search"
                       @click=" pager.pager.pageNumber = 1 ;doSearch()"></el-button>
          </div>
        </el-input>
      </el-col>
      <el-col :span="3">
        <el-select v-model="revstate" placeholder="confirm rcvd" multiple>
          <el-option
            v-for="item in fabrecs"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="3">
        <el-select v-model="selfabstatus" placeholder="fabrec status" multiple>
          <el-option
            v-for="item in options"
            :key="item"
            :label="item"
            :value="item">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="3">
        <el-select v-model="seltrimstatus" placeholder="trimrec status" multiple>
          <el-option
            v-for="item in options"
            :key="item"
            :label="item"
            :value="item">
          </el-option>
        </el-select>
      </el-col>
    </el-row>

    <el-table :data="pager.dataList" border stripe style="width: 100%">
      <el-table-column prop="id" label="ID" head-align="center" align="center" width="55"></el-table-column>
      <el-table-column prop="ctrefno" label="Ct.Ref.No." show-overflow-tooltip head-align="center" align="center"></el-table-column>
      <el-table-column prop="refno" label="Ref.No." show-overflow-tooltip head-align="center" align="center"></el-table-column>
      <el-table-column prop="cCompanySName" label="FACTORY" show-overflow-tooltip head-align="center" align="center"></el-table-column>
      <el-table-column prop="StyleNo" label="Style.No." show-overflow-tooltip head-align="center" align="center"></el-table-column>
      <el-table-column prop="PONo" label="Po.No." show-overflow-tooltip head-align="center" align="center"></el-table-column>
      <el-table-column prop="recievedate" label="RECIEVE.DATE" :formatter="formatRecdate" show-overflow-tooltip head-align="center" align="center">
      </el-table-column>

      <el-table-column  label="RCVD.MEMO" show-overflow-tooltip head-align="center" width ="120"  align="center">
      <template slot-scope="scope">
        <el-form :model="scope.row" :rules="$rules" ref="scope.row" >
          <el-form-item prop="resultmemo">
            <el-input v-show="true" size="small" v-model="scope.row.resultmemo"  style="width:100px"></el-input>
          </el-form-item>
        </el-form>
      </template>
      </el-table-column>


      <el-table-column  label="REC.STATUS" show-overflow-tooltip head-align="center" align="center">
        <template slot-scope="scope">
          <el-form :model="scope.row" :rules="$rules" ref="scope.row" >
            <el-form-item prop="recievestatus">
              <el-select v-model="scope.row.recievestatus" placeholder="pls select">
                <el-option
                  v-for="item in options"
                  :key="item"
                  :label="item"
                  :value="item">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </template>

      </el-table-column>
      <el-table-column  prop="recievememo" label="FAB.MEMO" show-overflow-tooltip head-align="center" align="center"></el-table-column>
      <el-table-column prop="trimrec_status" label="TRIM.STATUS" show-overflow-tooltip head-align="center" align="center">
        <template slot-scope="scope">
          <el-form :model="scope.row" :rules="$rules" ref="scope.row" >
            <el-form-item prop="trimrec_status">
              <el-select v-model="scope.row.trimrec_status" placeholder="pls select">
                <el-option
                  v-for="item in options"
                  :key="item"
                  :label="item"
                  :value="item">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </template>
      </el-table-column>
      <el-table-column prop="trimrec_memo" label="TRIM.MEMO" show-overflow-tooltip head-align="center" align="center"></el-table-column>
      <el-table-column prop="estadate" :formatter="formatRecdate" label="ETA" show-overflow-tooltip head-align="center" align="center"></el-table-column>

      <el-table-column label="SAVE" show-overflow-tooltip header-align="center" align="center" width="120">
        <template slot-scope="scope">
          <el-button-group>

            <el-button title="Rcv" size="mini" type="primary" icon="el-icon-circle-check"
                       @click="handleEdit(scope.$index,scope.row)"></el-button>
            <el-button title="Detail" size="mini" type="primary" icon="el-icon-document"
                       @click="doSearchDoc(scope.$index,scope.row)"></el-button>

          </el-button-group>
        </template>
      </el-table-column>
    </el-table>
    <el-row>
      <el-col :span="6" :offset="18">
        <el-pagination background small style="float:right" layout="prev, pager, next"
                       :total="pager.pager.recordCount" :page-size="pager.pager.pageSize"
                       :current-page.sync="pager.pager.pageNumber" v-show="pager.pager.pageCount != 0"
                       @current-change="changePage">
        </el-pagination>
      </el-col>
    </el-row>

    <!-- 弹框区域-->
    <el-dialog :title="ShipDetail" :visible.sync="addEditShow" width="90%">
      <el-table :data="details" border stripe style="width: 100%">
        <el-table-column prop="cCName" label="Name" head-align="center" align="center"></el-table-column>
        <el-table-column prop="Color" label="Color" head-align="center" align="center" width="100"></el-table-column>
        <el-table-column prop="Spec1" label="Spec1" head-align="center" align="center" width="180"></el-table-column>
        <el-table-column prop="Spec2" label="Spec2" head-align="center" align="center" width="180"></el-table-column>
        <el-table-column prop="Unit" label="Unit" head-align="center" align="center" width="60"></el-table-column>
        <el-table-column prop="QtyOrder" label="Order.Qty." head-align="center" align="center" width="100"></el-table-column>
        <el-table-column prop="ShipQty" label="Plan.Qty" head-align="center" align="center" width="100"></el-table-column>
        <el-table-column prop="TotalShipQty" label="Act.Shipped" head-align="center" align="center" width="100"></el-table-column>
        <el-table-column prop="Rolls" label="Rolls" head-align="center" align="center" width="60"></el-table-column>
        <el-table-column prop="Diff" label="Balance" head-align="center" align="center" width="100"></el-table-column>
        <el-table-column prop="RecStatus" label="Status" head-align="center" align="center" width="80"></el-table-column>
        <el-table-column prop="cCompanyNameAcc" label="Supplier" head-align="center" align="center" width="100"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addEditShow = false ;">确 定</el-button>
      </div>
    </el-dialog>

  </section>

</template>
<style>
  .el-form-item {
    margin-bottom: 0;
  }
  .el-table .cell.el-tooltip {
    white-space: pre-wrap;
    max-lines: 2;
  }
</style>

<script>
  import ElCol from "element-ui/packages/col/src/col";
  export default {
    components: {ElCol},
    data() {
      return {
        searchKey: "",
        pager: {
          pager: {
            pageCount: 0,
            pageNumber: 1,
            pageSize: 15,
            recordCount: 0
          }
        },
        ShipDetail: "Ship Detail",
        selected: [],
        details: [],
        addEditShow: false,
        grantShow: false,
        config: {
          id: 0,
          recievedate: "",
          recievestatus: "",
          recievememo: "",
          updateuser:""
        },
        formLabelWidth: "120px",
        options: ['FINISH','PARTIAL','CANCEL',''],
        selfabstatus:[],
        seltrimstatus :[],
        fabrecs:[{value:'1',label:'NOT RCVD'},{value:'2',label:'RCVD'}],
        revstate:['1']
      };
    },
    computed: {
      dialogWidth() {
        return 590 * 100 / this.$utils.windowWidth() + "%";
      }
    },
    watch: {
      options: function () {
        this.selected = [];
        this.options.forEach(item => {
          if (item.selected) {
            this.selected.push(item.key);
          }
        });
      }
    },
    methods: {
      changePage() {
        if (this.searchKey) {
          this.doSearch();
        } else {
          this.loadData();
        }
      },
      doSearchDoc(index, row){
        let OrderSn = row.iPoOrderInfoSn;
        let VesselSn = row.iVesselSn;
        this.$api.FabricRecieve.searchdoc(
          OrderSn,
          VesselSn,
          result => {
            this.details = result.pager;
            this.addEditShow = true;
          }
        );
      },
      doSearch() {
        let searchs = this.searchKey+"#"+this.revstate+"#"+this.selfabstatus+"#"+this.seltrimstatus
        this.$api.FabricRecieve.search(
          this.pager.pager.pageNumber,
          searchs,
          result => {
            this.pager = result.pager;

          }
        );


      },
      saveOrUpdateRole(formName) {
        this.$refs[formName].validate(valid => {
          if (valid) {

            var callback = result => {
              this.changePage();
              this.addEditShow = false;
            };
            this.$api.FabricRecieve.update(this.config, callback)

          } else {
            return false;
          }
        });
      },
      handleEdit(index, row) {

        row.recievedate = this.$utils.formatDate.format(new Date(),"yyyy-MM-dd");
        row.trimrec_date = this.$utils.formatDate.format(new Date(),"yyyy-MM-dd");
        row.update_user = this.$store.state.loginUser.name;
        let savestatus = row.recievestatus;
        row.recievestatus = "";
        row.recievestatus = savestatus;
        this.config = row;


        var callback = result => {

          if(result.poshiprecieve != undefined){

          } else {
            this.config.recievedate = null;
            this.config.trimrec_date = null;
            this.config.update_user = "";
            let savestatus = this.config.recievestatus;
            this.config.recievestatus = "";
            this.config.recievestatus = savestatus;
            this.$message({
              type: "error",
              message: "post error!"
            });
          }
          this.addEditShow = false;
        };
        this.$api.FabricRecieve.update(this.config, callback);
        this.addEditShow = false;
      },
      formatRecdate(row ,column){
          if(row[column.property] === "" || row[column.property] == null){

              return "";
          }else{

              return  row[column.property].substr(0,10);
          }
      },
      onStatusChange(){
        if(this.config.recievedate === "" || this.config.recievedate == null)
          this.config.recievedate = this.$utils.formatDate.format(new Date(),"yyyy-MM-dd");
      },
      loadData() {
        this.$api.FabricRecieve.list(this.pager.pager.pageNumber, result => {
          this.pager = result.pager;
        });
      }
    },
    created: function () {
      this.loadData();
    }
  };
</script>



// WEBPACK FOOTER //
// src/views/order/FabricRecieve.vue